var $body, $url;
var count = 0;
var secondsCountdown;

export default function landings() {

    $body = $('body');
    $url = $('#video').attr('src');

    if($body.hasClass('landingspage')) {
        count = 3;
        secondsCountdown = setInterval(function() { handleTimer(count); }, 800);
    }

    $('.close--link').on('click', function() {
        $('.video-pp').fadeOut();
        stopVideo();
    });

    $('#play_btn').on('click', function() {
        showOverlay();
    });
}

function stopVideo() {
    $('#video').attr('src', '');
    $('#video').attr('src', $url);
}

function showOverlay() {
    $('.video-pp').fadeIn();
    $body.addClass('overflow');
    $('#video')[0].src += "&autoplay=1";
}

function endCountdown() {
    showOverlay();
    $('#count_num').fadeOut();
    $('#play_btn').fadeIn();
}

function handleTimer() {
    if(count === 0) {
        clearInterval(secondsCountdown);
        endCountdown();
    } else {
        $('#count_num').html(count);
        count--;
    }
}


// WEBPACK FOOTER //
// ./src/Resources/ui/js/landings.js